import { CartProductProps } from '@ui/cart/cart-product.tsx';
import { FavoriteListStatus } from '@ui/favorite/favorite-list-status.tsx';
import { ProductCard } from '@ui/product/product-card.tsx';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { Spinner } from '@heroui/react';

export const FavoriteProductsList = ({
  items = [],
  isLoading = false,
  hasNextPage = false,
  onLoadMore,
}: {
  items?: (CartProductProps | undefined)[];
  isDivided?: boolean;
  isLoading?: boolean;
  hasNextPage?: boolean;
  onLoadMore: () => void;
}) => {
  const [infiniteRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage: hasNextPage,
    onLoadMore: onLoadMore,
  });

  if (!items || items.length === 0) {
    return <FavoriteListStatus variant="empty" />;
  }
  return (
    <div className="flex flex-col items-center justify-between py-3">
      <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 lg:gap-x-4 gap-y-6 lg:gap-y-8 w-full">
        {items.map((item, index) => (
          <li key={index}>
            <ProductCard {...item} />
          </li>
        ))}
      </ul>
      <Spinner variant="wave" ref={infiniteRef} className="hidden" />
    </div>
  );
};
